module.exports = __webpack_public_path__ + "static/media/user.7375f98c.svg";